const configObject = {
  noPhotoMessage: 'There are no photos yet',
}

export default configObject
